import Vue from "vue";
import Router from "../router";

const { htmlToText } = require("html-to-text");
export default class OpenGraph extends Vue {

  static generateBreadcrumb(breadcrumbs: any): any {
    const itemListElement: any = [];
    let i = 1;
    for (const breadcrumb of breadcrumbs) {
      let link = "";
      if (i !== breadcrumbs.length) {

        link = window.location.origin + breadcrumb.link;
      } else {
        link = window.location.origin + Router.currentRoute.fullPath;
      }
      const element = {
        "@type": "ListItem",
        "item": link,
        "name": breadcrumb.text,
        "position": i,
      };
      i++;

      itemListElement.push(element);
    }

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemListElement,
    };

  }

  static generateProduct(product: any): any {
    let brand: { "@type": string; name: any; } | string = "";
    let description = "";
    if (product.brand && product.brand.value) {
      brand = {
        "@type": "Brand",
        "name": product.brand.value,
      };
    }
    if (product.descriptionLong && product.descriptionLong.value) {
      description = htmlToText(product.descriptionLong.value, {
        wordwrap: 130,
      });
    } else {
      if (product.descriptionShort && product.descriptionShort.value) {
        description = htmlToText(product.descriptionShort.value, {
          wordwrap: 130,
        });
      } else {
        if (product.description) {
          description = htmlToText(product.description, {
            wordwrap: 130,
          });
        }
      }
    }

    return {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": product.name,
      brand,
      description,
      "image": product.pictureCover.src,
      "gtin13": product.ean ? product.ean.value : "",
      "sku": product.refSocatec,
      "offers": {
        "@type": "Offer",
        "price": product.discountPrice ? product.discountPrice.toString() : product.taxIncludedPrice.toString(),
        "priceCurrency": "EUR",
        "url": window.location.origin + Router.currentRoute.fullPath,
        "itemCondition": "https://schema.org/NewCondition",
        "availability": product.stockQuantity === 0 ? "https://schema.org/OutOfStock" : product.stockQuantity > 5 ? "https://schema.org/InStock" : "https://schema.org/LimitedAvailability",
      },
    };
  }

}
